import React from "react";

export default function BlankPage() {
  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      {/* Página en blanco */}
    </div>
  );
}
